import React, { useContext } from 'react';
import { ProductOrderSummaryContainer, Typography } from '@adac-mp/components';
import { IOrderInfoDetails, OfferContext, getLabelValue } from '@adac-mp/shared';

interface IProductOrderSummarySectionProps {
	moduleType: string;
	orderDetails: IOrderInfoDetails[];
	className?: string;
}

export const ProductOrderSummarySection = ({
	moduleType,
	orderDetails,
	className = '',
}: IProductOrderSummarySectionProps) => {
	const { labels } = useContext(OfferContext);
	return (
		<div
			key={moduleType}
			className={`flex flex-col gap-3 relative ease-in-out duration-500 ${className}`}
			style={{ maxHeight: 3000 }}>
			<Typography className="inline-flex pl-4" color="title">
				{getLabelValue('mp.digital', labels) || 'Digitale'}{' '}
				{moduleType !== 'Vignette' ? getLabelValue('mp.tollSection', labels) : moduleType}
			</Typography>
			{orderDetails.map((orderItem, index) => (
				<ProductOrderSummaryContainer key={orderItem.orderDetailId} index={index} orderItem={orderItem} />
			))}
		</div>
	);
};
